import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class RequestError {
  constructor(status, responseText, options, xhr) {
    _defineProperty(this, "status", void 0);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "xhr", void 0);
    _defineProperty(this, "responseText", void 0);
    _defineProperty(this, "response", void 0);
    _defineProperty(this, "alert", void 0);
    this.status = status;
    this.responseText = responseText;
    this.options = options;
    this.xhr = xhr;
    try {
      this.response = JSON.parse(responseText != null ? responseText : 'null');
    } catch (e) {
      this.response = null;
    }
    this.alert = null;
  }
}
flarum.reg.add('core', 'common/utils/RequestError', RequestError);